import { render, staticRenderFns } from "./setting-pop.vue?vue&type=template&id=5f5179e0&scoped=true&"
import script from "./setting-pop.vue?vue&type=script&lang=js&"
export * from "./setting-pop.vue?vue&type=script&lang=js&"
import style0 from "./setting-pop.vue?vue&type=style&index=0&id=5f5179e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5179e0",
  null
  
)

export default component.exports